export default __webpack_public_path__ + "static/media/oldmine-diagram-top.93376209.svg";